/**
 * The kinds of Blank a Template can hold. Kept apart from templateBlanks so the
 * send check can recognise them without pulling in the date and currency
 * formatters.
 */
export const TEMPLATE_BLANK_TYPES = ["text", "date", "time", "amount"] as const;
export type TemplateBlankType = (typeof TEMPLATE_BLANK_TYPES)[number];

/** `text|date|time|amount`, for building patterns that recognise a Blank's type. */
export const TEMPLATE_BLANK_TYPE_PATTERN = TEMPLATE_BLANK_TYPES.join("|");
